<template>
  <section class="hero" aria-labelledby="hero-title">
    <img
      class="hero-bg"
      src="/images/shirtless-afro-american-musculary-sports-man-checking-time-wristwatch-after-workout.webp"
      alt=""
      aria-hidden="true"
      fetchpriority="high"
      loading="eager"
    />
    <div class="hero-inner">
      <div class="hero-content">
        <h1 id="hero-title" class="hero-title">
          Un sistema integrato<br class="desktop-break"> per la preparazione atletica della tua società
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroHowWeWork'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.hero {
  position: relative;
  color: $white;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 1;
  }
}

.hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 0;
}

.hero-inner {
  position: relative;
  z-index: 2;
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
}

.hero-content {
  width: 100%;
}

.desktop-break {
  display: none;
}

.hero-title {
  font-size: 2.2rem;
  line-height: 1.15;
  font-weight: 700;
}

@media (min-width: 768px) {
  .hero {
    height: 550px;
  }

  .hero-inner {
    padding: 64px 40px;
  }

  .desktop-break {
    display: block;
  }
}

@media (min-width: 1440px) {
  .hero-inner {
    padding: 80px 120px;
  }

  .hero-title {
    font-size: 3rem;
  }
}
</style>
